module.exports = __webpack_public_path__ + "img/percentage.d52525fd.svg";